import { SelectField } from '@/components/ui'
import { AccountTypeField } from './AccountTypeField'
import { CaseDetailFields } from './CaseDetailFields'
import { CaseFormSkeleton } from './CaseFormSkeleton'
import type { ProjectCaseForm } from './types'

interface ProjectCaseFieldsProps {
  form: ProjectCaseForm
}

// The editable case answers: type → that type's detail fields → account type.
export const ProjectCaseFields = ({ form }: ProjectCaseFieldsProps) => {
  if (!form.isLoaded) return <CaseFormSkeleton />

  return (
    <div className="flex flex-col gap-4">
      <div className="max-w-sm">
        <SelectField
          label="Case type"
          value={form.caseType}
          onValueChange={form.onCaseTypeChange}
          options={form.caseTypes.map(({ key, label }) => ({
            value: key,
            label,
          }))}
          placeholder="Select a case type"
          required
        />
      </div>

      <CaseDetailFields
        fields={form.fields}
        values={form.details}
        onChange={form.onDetailChange}
        onCommit={form.onDetailCommit}
      />

      <AccountTypeField
        options={form.accountTypes}
        value={form.accountsType}
        onChange={form.onAccountsChange}
      />
    </div>
  )
}
